module.exports = __webpack_public_path__ + "static/media/talk01_medium@2x.8b7ca587.jpg";